import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Disable browser's default scroll restoration to avoid conflicts
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }

        // Use a small timeout to ensure the DOM is ready and override any browser scroll restoration
        const timeoutId = setTimeout(() => {
            if (hash) {
                const element = document.getElementById(hash.substring(1));
                if (element) {
                    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                    element.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
                    return;
                }
            }
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        }, hash ? 120 : 0);

        return () => clearTimeout(timeoutId);
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
